import axios from 'axios';

import {apiUrlV2} from './constants';

export interface DigitalWalletConfigRequest {
  walletType: 'APPLE_PAY' | 'GOOGLE_PAY';
  description: string;
}

export interface GooglePayConfiguration {
  merchantId: string;
  merchantName: string;
  gateway: string;
  gatewayMerchantId: string;
  countryCode: string;
  currencyCode: string;
  allowedCardNetworks: string[];
  allowedCardAuthMethods: string[];
  environment: 'TEST' | 'PRODUCTION';
}

export interface ApplePayConfiguration {
  merchantId: string;
  merchantName: string;
  countryCode: string;
  currencyCode: string;
  supportedNetworks: string[];
  merchantCapabilities: string[];
  gateway: string;
  gatewayMerchantId: string;
  environment: 'TEST' | 'PRODUCTION';
}

export interface DigitalWalletConfigResponse {
  txId: string;
  walletType: 'APPLE_PAY' | 'GOOGLE_PAY';
  googlePayConfiguration?: GooglePayConfiguration;
  applePayConfiguration?: ApplePayConfiguration;
}

export interface HostedCheckoutCybersourceBillingInfo {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  country: string;
  locality: string;
  address1: string;
  address2?: string;
  postalCode: string;
}

export interface DigitalWalletCompleteRequest {
  txId: string;
  walletType: 'APPLE_PAY' | 'GOOGLE_PAY';
  token: string;
  clientReferenceId?: string;
  billingInfo?: HostedCheckoutCybersourceBillingInfo;
}

export interface DigitalWalletCompleteResponse {
  transaction: {
    id: string;
    status: string;
  };
  form?: {
    url: string;
    method: string;
    parameters?: Record<string, string>;
  };
}

export interface ApplePayMerchantValidationRequest {
  validationUrl: string;
}

export interface ApplePayMerchantValidationResponse {
  epochTimestamp: number;
  expiresAt: number;
  merchantSessionIdentifier: string;
  nonce: string;
  merchantIdentifier: string;
  domainName: string;
  displayName: string;
  signature: string;
  // Optional error fields returned by Apple Pay validation API
  statusCode?: string;
  statusMessage?: string;
  operationalAnalyticsIdentifier?: string;
}

export const getDigitalWalletConfig = async (
  sessionId: string,
  request: DigitalWalletConfigRequest
): Promise<DigitalWalletConfigResponse> => {
  const response = await axios.post<DigitalWalletConfigResponse>(
    `${apiUrlV2}/v1/hosted-checkout/${sessionId}/digitalwallet/config`,
    request
  );
  return response.data;
};

export const completeDigitalWalletPayment = async (
  sessionId: string,
  request: DigitalWalletCompleteRequest
): Promise<DigitalWalletCompleteResponse> => {
  const response = await axios.post<DigitalWalletCompleteResponse>(
    `${apiUrlV2}/v1/hosted-checkout/${sessionId}/digitalwallet`,
    request
  );
  return response.data;
};

export const validateMerchantDigitalWalletPayment = async (
  sessionId: string,
  request: ApplePayMerchantValidationRequest
): Promise<ApplePayMerchantValidationResponse> => {
  const response = await axios.post<ApplePayMerchantValidationResponse>(
    `${apiUrlV2}/v1/hosted-checkout/${sessionId}/digitalwallet/verifymerchant`,
    request
  );
  return response.data;
};
